import $ from 'jquery';
import { repository } from 'repositories/matchCalendarRepository';
import { matchCalendarModel } from 'models/MatchCalendarModel';
import MatchHeadingView from 'ui/matchCalendar/match-heading-view';
import MatchWrapper from 'ui/matchCalendar/match-wrapper-view';

export const init = (params) => {
    /*
     * Exit component when suspended season state
     */
    const suspended = window.rmpl.get('matches', 'suspended');
    if (suspended) {
        return false;
    }

    const elements = {
        container: '.match'
    }

    $(document).ready(() => {
      repository
          .load()
          .then((data) => {
              const activeDay = repository.getCurrentDay();

              matchCalendarModel.fromJSON(data);
              matchCalendarModel.setCurrentDay(activeDay);

              /**
               * @TODO
               * move after match endpoint request
               *
               * const firstDayData = repository.getFirstDay();
               * matchCalendarModel.getCurrentDay().fromJSON(firstDayData);
               */

              const matchHeadingView = new MatchHeadingView(matchCalendarModel);
              matchHeadingView.render();

              const matchWrapper = new MatchWrapper(matchCalendarModel);
              matchWrapper.render();

              /**
               * @TODO
               * move after match endpoint request
               *
               * if (repository.isFirstMatchLive()) {
               *     controller.registerLiveUpdate(activeDay);
               * }
               */
          }).then(() => {
              $(elements.container).removeClass('is-loading');
          });
    });
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/index.js